import React from "react";
import DashboardTile from "../../DashboardTile";
import gettext from "../../../shared/utils/gettext";
import useCostsData, { CostsAggregateType } from "./useCostsData";
import DashboardCostsGraph from "./DashboardCostsGraph";
import cropr from "../../../shared/utils/cropr";
import useLocalStorageState from "use-local-storage-state";

// Berekening uitvoeren in client op basis van cropr.records + kosten-config
// Eenmalige kosten overslaan (pacht, etc)

function DashboardCostsTile() {
  const [aggregate, setAggregate] = useLocalStorageState<CostsAggregateType>(
    "DashboardCostsTileAggregateType",
    "day"
  );
  const data = useCostsData({ aggregate });

  return (
    <DashboardTile experimental>
      <DashboardTile.Title
        right={
          cropr.features.pro && (
            <span className="records-tile activity-select w-50">
              <select
                className="custom-select"
                defaultValue={aggregate}
                // @ts-ignore
                onChange={(v) => setAggregate(v.target.value)}
              >
                <option value="day">{gettext("Day")}</option>
                <option value="week">{gettext("Week")}</option>
                <option value="month">{gettext("Month")}</option>
              </select>
            </span>
          )
        }
      >
        {gettext("Your costs")}
      </DashboardTile.Title>
      {(cropr.features.pro && (
        <>
          {(data.total && (
            <>
              <DashboardTile.Body>
                <DashboardCostsGraph data={data} />
              </DashboardTile.Body>
              <DashboardTile.Footer>
                <a
                  href="/cropr/dashboard/#financial/"
                  className="js-log-metric"
                  data-metrics_category="dashboard_links"
                >
                  {gettext("Show financial details")}
                </a>
              </DashboardTile.Footer>
            </>
          )) || <DashboardCostsTile.NoData />}
        </>
      )) || <DashboardCostsTile.BuyPro />}
    </DashboardTile>
  );
}

DashboardCostsTile.NoData = () => (
  <>
    <DashboardTile.Body>
      <p>{gettext("No costs recorded during the selected period.")}</p>
      <p>
        {gettext("Would you like up to date insight into your costs? This is possible with Dacom.")}
      </p>
    </DashboardTile.Body>
    <DashboardTile.Footer>
      <a
        href="/cropr/settings/financial/"
        className="js-log-metric"
        data-metrics_category="dashboard_links"
      >
        {gettext("Click here")}
      </a>
      &nbsp;
      {gettext("to configure your costs.")}
    </DashboardTile.Footer>
  </>
);
DashboardCostsTile.BuyPro = () => (
  <>
    <DashboardTile.Body>
      {gettext("You need a pro subscription to get costs insights")}
    </DashboardTile.Body>
    <DashboardTile.Link
      url="/subscription/order/"
      text={gettext("Buy Dacom pro subscription")}
      experimental
      logMetrics={true}
    />
  </>
);
export default DashboardCostsTile;
